import { atom } from 'jotai'

import { LoginFormSettingEntity } from 'src/types'

type Input = Omit<LoginFormSettingEntity, 'email'> & {
  canShowLoginForm: boolean
  email: string | null
}

const state = atom<Input>({
  email: null,
  canShowLoginForm: false,
  isIDPassEnabled: false,
  isSAMLEnabled: false,
  isSuperAdmin: false,
})
export const checkLoginSettingStore = { state } as const
